import { render, staticRenderFns } from "./ChangePw.vue?vue&type=template&id=2803ea2e"
import script from "./ChangePw.js?vue&type=script&lang=js&external"
export * from "./ChangePw.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports